import React, { CSSProperties } from 'react';

interface IProps {
	children: string,
	className?: string,
	style?: CSSProperties
}

function ContainerSectionTitle(props: IProps) {
	let className = 'container-section-title';
	if (props.className) className += ' ' + props.className;

	return (
		<h3 className={className} style={props.style}>{props.children}</h3>
	);
}

export default ContainerSectionTitle;